import _styled from "styled-components";
import React, { Fragment, useEffect } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import DesktopModal from './desktop-modal';
import { MobileModalWithGestures } from './mobile-modal-with-gestures';
import { useModalBreakPoints } from './use-modal-break-points';
import { jsx as _jsx } from "react/jsx-runtime";
export function BaseModal(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'center' : _ref$variant,
      closeIcon = _ref.closeIcon,
      dragHandleIcon = _ref.dragHandleIcon,
      showBackButton = _ref.showBackButton,
      onClose = _ref.onClose,
      backIcon = _ref.backIcon,
      onBack = _ref.onBack,
      _ref$showMobileGestur = _ref.showMobileGestures,
      showMobileGestures = _ref$showMobileGestur === void 0 ? true : _ref$showMobileGestur,
      open = _ref.open,
      title = _ref.title,
      children = _ref.children,
      modalStyles = _ref.modalStyles,
      noPadding = _ref.noPadding,
      showDragHandleIcon = _ref.showDragHandleIcon,
      _ref$withTransition = _ref.withTransition,
      withTransition = _ref$withTransition === void 0 ? true : _ref$withTransition,
      _ref$hideHeader = _ref.hideHeader,
      hideHeader = _ref$hideHeader === void 0 ? false : _ref$hideHeader,
      showCloseIcon = _ref.showCloseIcon,
      footer = _ref.footer,
      footerStyles = _ref.footerStyles,
      primaryActionLabel = _ref.primaryActionLabel,
      onClickPrimaryAction = _ref.onClickPrimaryAction,
      secondaryActionLabel = _ref.secondaryActionLabel,
      onClickSecondaryAction = _ref.onClickSecondaryAction,
      padBodyBottom = _ref.padBodyBottom,
      hasHeaderBorderBottom = _ref.hasHeaderBorderBottom,
      headerStyles = _ref.headerStyles,
      CloseIcon = _ref.CloseIcon,
      disableDrag = _ref.disableDrag,
      modalBodyStyles = _ref.modalBodyStyles,
      hasOffWhiteBackground = _ref.hasOffWhiteBackground,
      _ref$disableOverlayCl = _ref.disableOverlayClose,
      disableOverlayClose = _ref$disableOverlayCl === void 0 ? false : _ref$disableOverlayCl;

  var _useModalBreakPoints = useModalBreakPoints(),
      isDesktop = _useModalBreakPoints.isDesktop;

  useEffect(function () {
    if (open) {
      document.documentElement.style.scrollBehavior = 'auto';
      document.body.style.scrollBehavior = 'auto';
      document.body.style.overflow = 'visible';
    } else {
      document.documentElement.style.scrollBehavior = 'auto';
      document.body.style.scrollBehavior = 'auto';
    }

    return function () {
      document.documentElement.style.scrollBehavior = 'auto';
      document.body.style.scrollBehavior = 'auto';
    };
  }, [open]);

  var desktopModalEl = /*#__PURE__*/_jsx(DesktopModal, {
    variant: variant,
    closeIcon: closeIcon,
    showBackButton: showBackButton,
    onClose: onClose,
    backIcon: backIcon,
    onBack: onBack,
    open: open,
    title: title,
    noPadding: noPadding,
    modalStyles: modalStyles,
    withTransition: withTransition,
    hideHeader: hideHeader,
    showCloseIcon: showCloseIcon,
    footer: footer,
    footerStyles: footerStyles,
    primaryActionLabel: primaryActionLabel,
    onClickPrimaryAction: onClickPrimaryAction,
    secondaryActionLabel: secondaryActionLabel,
    onClickSecondaryAction: onClickSecondaryAction,
    headerStyles: headerStyles,
    CloseIcon: CloseIcon,
    modalBodyStyles: modalBodyStyles,
    hasOffWhiteBackground: hasOffWhiteBackground,
    children: children
  });

  var mobileModalWithGestureEl = /*#__PURE__*/_jsx(MobileModalWithGestures, {
    variant: variant,
    dragHandleIcon: dragHandleIcon,
    showBackButton: showBackButton,
    onClose: onClose,
    backIcon: backIcon,
    onBack: onBack,
    showMobileGestures: showMobileGestures,
    open: open,
    title: title,
    children: children,
    noPadding: noPadding,
    modalStyles: modalStyles,
    showDragHandleIcon: showDragHandleIcon,
    footer: footer,
    footerStyles: footerStyles,
    primaryActionLabel: primaryActionLabel,
    onClickPrimaryAction: onClickPrimaryAction,
    secondaryActionLabel: secondaryActionLabel,
    onClickSecondaryAction: onClickSecondaryAction,
    padBodyBottom: padBodyBottom,
    hasHeaderBorderBottom: hasHeaderBorderBottom,
    headerStyles: headerStyles,
    disableDrag: disableDrag,
    hasOffWhiteBackground: hasOffWhiteBackground
  });

  return /*#__PURE__*/_jsx(Transition, {
    appear: true,
    show: open,
    as: Fragment,
    enter: "ease-out duration-200",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "ease-in-out duration-300",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0",
    children: /*#__PURE__*/_jsx(StyledDialog, {
      onClose: disableOverlayClose ? function () {
        return undefined;
      } : onClose,
      "data-cy": "base-modal",
      children: /*#__PURE__*/_jsx(Transition.Child, {
        as: Fragment,
        enter: "transition-opacity ease-out duration-300",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "transition-opacity ease-in duration-200",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        children: /*#__PURE__*/_jsx(Container, {
          variant: variant,
          children: isDesktop ? withTransition ? /*#__PURE__*/_jsx(ModalTransition, {
            variant: variant,
            children: desktopModalEl
          }) : desktopModalEl : mobileModalWithGestureEl
        })
      })
    })
  });
}

var StyledDialog = /*#__PURE__*/_styled(Dialog).withConfig({
  displayName: "base-modal__StyledDialog",
  componentId: "sc-1dkru51-0"
})(function () {
  return [{
    "position": "fixed",
    "top": "0px",
    "left": "0px",
    "zIndex": "100",
    "boxSizing": "border-box",
    "display": "flex",
    "height": "100dvh",
    "maxHeight": "100dvh",
    "width": "100%",
    "flexDirection": "column",
    "alignItems": "flex-start",
    "justifyContent": "flex-end",
    "overflow": "hidden"
  }];
});

var Container = /*#__PURE__*/_styled.div.withConfig({
  displayName: "base-modal__Container",
  componentId: "sc-1dkru51-1"
})(function (_ref2) {
  var variant = _ref2.variant;
  return [{
    "boxSizing": "border-box",
    "display": "flex",
    "height": "100dvh",
    "maxHeight": "100dvh",
    "width": "100%",
    "flexDirection": "column",
    "alignItems": "flex-start",
    "justifyContent": "flex-end",
    "overflow": "hidden",
    "overflowY": "hidden",
    "backgroundColor": "rgb(28 19 39 / 0.3)"
  }, variant === 'center' && {
    "@media (min-width: 768px)": {
      "alignItems": "center",
      "justifyContent": "center"
    },
    "@media (min-width: 1024px)": {
      "alignItems": "center",
      "justifyContent": "center"
    }
  }, variant === 'right' && {
    "@media (min-width: 768px)": {
      "alignItems": "flex-end"
    },
    "@media (min-width: 1024px)": {
      "alignItems": "flex-end"
    }
  }];
});

var ModalTransition = function ModalTransition(_ref3) {
  var variant = _ref3.variant,
      children = _ref3.children;
  return /*#__PURE__*/_jsx(Transition.Child, {
    as: Fragment,
    enter: variant === 'right' ? 'transition ease-in-out duration-200 transform' : 'ease-in-out duration-200',
    enterFrom: variant === 'right' ? 'translate-x-full' : 'opacity-0  scale-0',
    enterTo: variant === 'right' ? 'translate-x-0' : 'opacity-100 scale-100',
    leave: variant === 'right' ? 'ease-in-out duration-200' : 'ease-in duration-200',
    leaveFrom: variant === 'right' ? 'translate-x-0' : 'opacity-100 scale-100',
    leaveTo: variant === 'right' ? 'translate-x-full' : 'opacity-0 scale-95',
    children: children
  });
};